import { TableSettingsTableTypes } from "@enums/table-settings-table-types";
import {
    setTableSettingsTableExpanded,
    setTableSettingsTableFilters,
    setTableSettingsTablePagination,
    setTableSettingsTableSortBy
} from "@redux/actions/table-settings-actions";
import { ColumnFiltersState, ExpandedState, PaginationState, SortingState, Updater } from "@tanstack/react-table";
import { Dispatch } from "redux";

export const handleSetColumnFiltersChange = (
    filtersOrUpdateFn: Updater<ColumnFiltersState>,
    tableSettingsTableType: TableSettingsTableTypes,
    columnFilters: ColumnFiltersState,
    dispatch: Dispatch
) => {
    if (typeof filtersOrUpdateFn !== "function") {
        dispatch(setTableSettingsTableFilters(tableSettingsTableType, filtersOrUpdateFn));
    } else {
        const newFilters = filtersOrUpdateFn(columnFilters);
        dispatch(setTableSettingsTableFilters(tableSettingsTableType, newFilters));
    }
};

export const handleSetSortingChange = (
    sortingOrUpdateFn: Updater<SortingState>,
    tableSettingsTableType: TableSettingsTableTypes,
    sorting: SortingState,
    dispatch: Dispatch
) => {
    if (typeof sortingOrUpdateFn !== "function") {
        dispatch(setTableSettingsTableSortBy(tableSettingsTableType, sortingOrUpdateFn));
    } else {
        const newSorting = sortingOrUpdateFn(sorting);
        dispatch(setTableSettingsTableSortBy(tableSettingsTableType, newSorting));
    }
};

export const handleSetPaginationChange = (
    paginationOrUpdateFn: Updater<PaginationState>,
    tableSettingsTableType: TableSettingsTableTypes,
    pagination: PaginationState,
    dispatch: Dispatch
) => {
    if (typeof paginationOrUpdateFn !== "function") {
        dispatch(setTableSettingsTablePagination(tableSettingsTableType, paginationOrUpdateFn));
    } else {
        const newPagination = paginationOrUpdateFn(pagination);
        dispatch(setTableSettingsTablePagination(tableSettingsTableType, newPagination));
    }
};

export const handleSetExpandedChange = (
    expandedOrUpdateFn: Updater<ExpandedState>,
    tableSettingsTableType: TableSettingsTableTypes,
    expanded: ExpandedState,
    dispatch: Dispatch
) => {
    if (typeof expandedOrUpdateFn !== "function") {
        dispatch(setTableSettingsTableExpanded(tableSettingsTableType, expandedOrUpdateFn));
    } else {
        const newExpanded = expandedOrUpdateFn(expanded);
        dispatch(setTableSettingsTableExpanded(tableSettingsTableType, newExpanded));
    }
}